"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _constants = require("../constants");

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Main);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Main).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseLeave", function () {
      _this.setState({
        hidden: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleMouseEnter",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                hidden: false,
                docH: window.document.body.offsetHeight,
                docW: window.document.body.offsetWidth
              });

            case 2:
              _context.next = 4;
              return _this.setState({
                position: _this.getPosition()
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      hidden: true,
      position: props.position
    };
    _this.rootEl = _react["default"].createRef();
    _this.hintEl = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Main, [{
    key: "getPosition",
    value: function getPosition() {
      var _this$hintEl$current, _this$hintEl$current2, _this$rootEl$current;

      var _this$props = this.props,
          gap = _this$props.gap,
          position = _this$props.position,
          offset = (0, _documentOffset["default"])(this.rootEl.current),
          hintWidth = (_this$hintEl$current = this.hintEl.current) === null || _this$hintEl$current === void 0 ? void 0 : _this$hintEl$current.offsetWidth,
          hintHeight = (_this$hintEl$current2 = this.hintEl.current) === null || _this$hintEl$current2 === void 0 ? void 0 : _this$hintEl$current2.offsetHeight,
          elWidth = (_this$rootEl$current = this.rootEl.current) === null || _this$rootEl$current === void 0 ? void 0 : _this$rootEl$current.offsetWidth;
      var result = position; // нет места снизу

      if ((offset === null || offset === void 0 ? void 0 : offset.top) + hintHeight + gap > this.state.docH) {
        if (result === _constants.POSITION_LEFT_TOP) {
          result = _constants.POSITION_LEFT_BOTTOM;
        } else if (result === _constants.POSITION_RIGHT_TOP) {
          result = _constants.POSITION_RIGHT_BOTTOM;
        } else if (result === _constants.POSITION_BOTTOM_RIGHT) {
          result = _constants.POSITION_TOP_RIGHT;
        } else if (result === _constants.POSITION_BOTTOM_LEFT) {
          result = _constants.POSITION_TOP_LEFT;
        } else if (result === _constants.POSITION_BOTTOM_CENTER) {
          result = _constants.POSITION_TOP_CENTER;
        }
      } // нет места сверху


      if ((offset === null || offset === void 0 ? void 0 : offset.top) - hintHeight - gap <= 0) {
        if (result === _constants.POSITION_TOP_RIGHT) {
          result = _constants.POSITION_BOTTOM_RIGHT;
        } else if (result === _constants.POSITION_TOP_LEFT) {
          result = _constants.POSITION_BOTTOM_LEFT;
        } else if (result === _constants.POSITION_RIGHT_BOTTOM) {
          result = _constants.POSITION_RIGHT_TOP;
        } else if (result === _constants.POSITION_LEFT_BOTTOM) {
          result = _constants.POSITION_LEFT_TOP;
        } else if (result === _constants.POSITION_TOP_CENTER) {
          result = _constants.POSITION_BOTTOM_CENTER;
        }
      } // нет места справа


      if ((offset === null || offset === void 0 ? void 0 : offset.left) + elWidth + hintWidth + gap > this.state.docW) {
        if (result === _constants.POSITION_RIGHT_BOTTOM) {
          result = _constants.POSITION_LEFT_BOTTOM;
        } else if (result === _constants.POSITION_RIGHT_TOP) {
          result = _constants.POSITION_LEFT_TOP;
        } else if (result === _constants.POSITION_RIGHT_CENTER) {
          result = _constants.POSITION_LEFT_CENTER;
        }
      } // нет места справа при размещении поднизом


      if ((offset === null || offset === void 0 ? void 0 : offset.left) + hintWidth > this.state.docW) {
        if (result === _constants.POSITION_TOP_LEFT) {
          result = _constants.POSITION_TOP_RIGHT;
        } else if (result === _constants.POSITION_BOTTOM_LEFT) {
          result = _constants.POSITION_BOTTOM_RIGHT;
        }
      } // нет места слева


      if ((offset === null || offset === void 0 ? void 0 : offset.left) - (elWidth + hintWidth + gap) <= 0) {
        if (result === _constants.POSITION_LEFT_TOP) {
          result = _constants.POSITION_RIGHT_TOP;
        } else if (result === _constants.POSITION_LEFT_BOTTOM) {
          result = _constants.POSITION_RIGHT_BOTTOM;
        } else if (result === _constants.POSITION_LEFT_CENTER) {
          result = _constants.POSITION_RIGHT_CENTER;
        }
      } // нет места слева при размещении поднизом


      if ((offset === null || offset === void 0 ? void 0 : offset.left) < hintWidth - elWidth) {
        if (result === _constants.POSITION_TOP_RIGHT) {
          result = _constants.POSITION_TOP_LEFT;
        } else if (result === _constants.POSITION_BOTTOM_RIGHT) {
          result = _constants.POSITION_BOTTOM_LEFT;
        }
      }

      return result;
    }
  }]);
  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  position: _constants.POSITION_RIGHT_TOP,
  dark: false,
  inline: false,
  "short": false,
  middle: false,
  "long": false,
  wide: false,
  multiLine: true,
  gap: 16
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  multiLine: _propTypes["default"].bool,
  dark: _propTypes["default"].bool,
  labelClassName: _propTypes["default"].string,
  children: _propTypes["default"].any.isRequired,
  label: _propTypes["default"].any.isRequired,
  inline: _propTypes["default"].bool,
  wide: _propTypes["default"].bool,
  "long": _propTypes["default"].bool,
  middle: _propTypes["default"].bool,
  "short": _propTypes["default"].bool,

  /**
   * gap between document borders
   */
  gap: _propTypes["default"].number,

  /**
   * default position
   */
  position: _propTypes["default"].oneOf([_constants.POSITION_BOTTOM_CENTER, _constants.POSITION_BOTTOM_LEFT, _constants.POSITION_BOTTOM_RIGHT, _constants.POSITION_LEFT_BOTTOM, _constants.POSITION_LEFT_CENTER, _constants.POSITION_LEFT_TOP, _constants.POSITION_RIGHT_BOTTOM, _constants.POSITION_RIGHT_CENTER, _constants.POSITION_RIGHT_TOP, _constants.POSITION_TOP_CENTER, _constants.POSITION_TOP_LEFT, _constants.POSITION_TOP_RIGHT]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    borderColor: _propTypes["default"].string,

    /**
     * @default 0 8px 12px 0 ${palette.elShadow}, 0 6px 12px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    linkColor: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default palette.tsXSmall
     */
    labelFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlXSmall
     */
    labelLineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter / 2
     */
    triangleWidth: _propTypes["default"].number,

    /**
     * @default left
     */
    textAlign: _propTypes["default"].string,

    /**
     * @default 0
     * @description hint offset relative to current position
     */
    top: _propTypes["default"].number,

    /**
     * @default 0
     */
    left: _propTypes["default"].number,

    /**
     * @default palette.gutter * 30 + 'px'
     */
    maxWidth: _propTypes["default"].string,

    /**
     * @default palette.gutter * 20 + 'px'
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default color(palette.elBlack).hex()
     */
    darkBackground: _propTypes["default"].string,

    /**
     * @default color(palette.elBlack).hex()
     */
    darkBorderColor: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    darkColor: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'Hint');
var _default = Main;
exports["default"] = _default;